import { render, staticRenderFns } from "./DownloadAsPDF.vue?vue&type=template&id=0ae86a5a"
import script from "./DownloadAsPDF.vue?vue&type=script&lang=js"
export * from "./DownloadAsPDF.vue?vue&type=script&lang=js"
import style0 from "./DownloadAsPDF.vue?vue&type=style&index=0&id=0ae86a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports